import { render, staticRenderFns } from "./DecisionChangeCard.vue?vue&type=template&id=5e273b6c&scoped=true&"
import script from "./DecisionChangeCard.vue?vue&type=script&lang=ts&"
export * from "./DecisionChangeCard.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionChangeCard.vue?vue&type=style&index=0&id=5e273b6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e273b6c",
  null
  
)

export default component.exports